import { formatMessage } from 'utils/messages/utils';

export const generateDialogMessage = (
  numberToDelete: number,
  isTGSelected: boolean,
  isBulkDeleteChecked = false,
  numberToLeaveOut = 0
): string => {
  if (!isBulkDeleteChecked) {
    if (isTGSelected) {
      return numberToDelete <= 1
        ? formatMessage('DELETE_TG_TERRITORY_CONFIRM', { count: numberToDelete })
        : formatMessage('DELETE_TG_TERRITORIES_CONFIRM', { count: numberToDelete });
    }
    return numberToDelete <= 1
      ? formatMessage('DELETE_BC_TERRITORY_CONFIRM', { count: numberToDelete })
      : formatMessage('DELETE_BC_TERRITORIES_CONFIRM', { count: numberToDelete });
  }

  if (isBulkDeleteChecked && numberToLeaveOut === 0) {
    return isTGSelected
      ? formatMessage('DELETE_ALL_TERRITORY_GROUP_TERRITORIES_CONFIRMATION_MESSAGE')
      : formatMessage('DELETE_ALL_BATTLECARD_TERRITORIES_CONFIRMATION_MESSAGE');
  } else {
    if (isTGSelected) {
      return numberToLeaveOut <= 1
        ? formatMessage('DELETE_TG_TERRITORY_WITH_EXCEPTION', { count: numberToLeaveOut })
        : formatMessage('DELETE_TG_TERRITORIES_WITH_EXCEPTION', { count: numberToLeaveOut });
    }
    return numberToLeaveOut <= 1
      ? formatMessage('DELETE_BC_TERRITORY_WITH_EXCEPTION', { count: numberToLeaveOut })
      : formatMessage('DELETE_BC_TERRITORIES_WITH_EXCEPTION', { count: numberToLeaveOut });
  }
};
